import { APIUrls } from "../../Constants/ApiUrls";
import { ISensor } from "../../Models/ISensor";
// import { ISentinel } from "../../Models/ISentinel"; //Fix Warning Complaint Code:071225
import { AjaxService, IAPIRequest, IAPIResponse } from "../AjaxService";

const SensorController = {
  GetAllSensors: async (callback?: (response: IAPIResponse) => void) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENSORS.SENSORS_URL;
    request.allowApiCache = true;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  EditOrCreateSensor: async (
    sensor: ISensor,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENSORS.SENSOR_EDIT_OR_CREATE;
    request.method = "POST";
    request.payload = sensor;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
  DeleteSensor: async (
    sensor: ISensor,
    callback?: (response: IAPIResponse) => void
  ) => {
    let request: IAPIRequest = AjaxService.GetEmptyRequest();
    request.url = APIUrls.SENSORS.SENSOR_DELETE;
    request.method = "DELETE";
    request.payload = sensor;
    let response = await AjaxService.APICall(request, callback);
    return response;
  },
};

export default SensorController;
